import * as React from 'react';
import { useState } from 'react';
import firebase from "firebase/compat/app";
import { useAuthContext } from '../../Modules/Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { db } from '../../Environment/firebase';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Card } from '@mui/material';
import { CardContent } from '@mui/material';
import { FormControl } from "@mui/material";
import { InputLabel } from "@mui/material";
import  Select,{ SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import FormHelperText from '@mui/material/FormHelperText';
import { grades, departments,prefectures } from '../../Environment/Config';


export default function ChangeForms() {

    const { user, userData, userDataId } = useAuthContext();


    const [nickname, setNickname] = useState(userData?.nickname || '');
    const [position, setPosition] = useState(userData?.position || '');
    const [belongs, setBelongs] = useState(userData?.belongs || '');
    const [prefecture,setPrefecture] = useState(userData?.prefecture || 0);
    const [magazine, setMagazine] = useState(userData?.magazine || false);
    const [grade, setGrade] = useState(userData?.grade || 0);
    const [department, setDepartment] = useState(userData?.department || 0);

    const navigate = useNavigate();

    const handleGrade = (event:SelectChangeEvent) => {
        setGrade(parseInt(event.target.value as string))
    }

    const handleDepartment = (event:SelectChangeEvent) => {
        setDepartment(parseInt(event.target.value as string))
    }

    const handlePrefecture = (event:SelectChangeEvent) => {
        setPrefecture(parseInt(event.target.value as string))
      }

    const data = {
        uid:user?.uid || '',
        nickname: nickname,
        position: position,
        belongs: belongs,
        magazine: magazine,
        photoURL: user?.photoURL || '',
        grade: grade,
        prefecture: prefecture,
        department: department,
        changeTime: firebase.firestore.FieldValue.serverTimestamp(),
    };

    type UserDataType = {
        uid: string,
        nickname: string | null,
        position: string,
        belongs: string,
        photoURL: string,
        grade: number,
        prefecture:number,
        department: number,
        magazine: boolean,
        changeTime: firebase.firestore.FieldValue
      }


    const updateUser = (data:UserDataType) => {
        db.collection("users")
            .doc(userDataId || '')
            .set(data, { merge: true })
            .then(() => {
                navigate("/mypage/dashboard");
                console.log("Document successfully written!");
                return <div>Document successfully written!</div>;
            })
            .catch((err) => {
                console.log("error:", err);
            });
    };
    return (
        <div>
            <Container component="main" maxWidth="xs" sx={{ mt: 3 }}>
                <Card sx={{ mt: 3 }}>
                    <CardContent>
                        <Box
                            sx={{
                                marginTop: 8,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                <LockOutlinedIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                カスタム情報変更
                            </Typography>

                            <div>
                                <Grid container spacing={2} sx={{ mt: 3 }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            label="ニックネーム"
                                            defaultValue={nickname}
                                            variant="filled"
                                            onChange={(event) => setNickname(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            required
                                            id="filled-required"
                                            label="身分"
                                            defaultValue={position}
                                            variant="filled"
                                            onChange={(event) => setPosition(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">都道府県</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={prefecture.toString()}
                                            label="都道府県"
                                            onChange={handlePrefecture}
                                        >
                                            <MenuItem value={0}>None</MenuItem>
                                            {prefectures.map((element, index) => (
                                            <MenuItem value={index + 1}>{element}</MenuItem>
                                            ))}
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            required
                                            id="filled-disabled"
                                            label="所属"
                                            defaultValue={belongs}
                                            variant="filled"
                                            onChange={(event) => setBelongs(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">学年</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={grade.toString()}
                                                label="学年"
                                                onChange={handleGrade}
                                            >
                                                <MenuItem value={0}>None</MenuItem>
                                                {grades.map((element, index) => (
                                                    <MenuItem key={index + 1} value={index + 1}>{element}</MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText>学生の方のみ</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">診療科</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={department.toString()}
                                                label="診療科"
                                                onChange={handleDepartment}
                                            >
                                                <MenuItem value={0}>None</MenuItem>
                                                {departments.map((element, index) => (
                                                    <MenuItem key={index + 1} value={index + 1}>{element}</MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText>医師の方のみ</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={magazine === true}
                                                    onClick={() => setMagazine(!magazine)}
                                                    value="allowExtraEmails"
                                                    color="primary" />}
                                            label="メールマガジンを受け取る。"
                                        />
                                    </Grid>
                                </Grid>
                                <Button
                                    type="submit"
                                    fullWidth
                                    onClick={() => updateUser(data)}
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    変更
                                </Button>

                            </div>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </div>
    );
}